export default __webpack_public_path__ + "static/customers_column_create-3501352f20f3968f673b75d80f1bccd6.png";